
import ScrollAnimation from '../../../components/base/ScrollAnimation';

export default function TintShadesSection() {
  const shades = [
    { percentage: '5%', name: 'Limo Dark', description: 'Maximum privacy' },
    { percentage: '15%', name: 'Very Dark', description: 'High privacy' },
    { percentage: '20%', name: 'Dark', description: 'Popular choice' },
    { percentage: '30%', name: 'Medium Dark', description: 'Balanced look' },
    { percentage: '35%', name: 'Medium', description: 'Legal front' },
    { percentage: '40%', name: 'Light Medium', description: 'Subtle style' },
    { percentage: '50%', name: 'Light', description: 'Minimal tint' },
    { percentage: '70%', name: 'Very Light', description: 'UV protection' },
  ];

  return (
    <section className="py-24 max-md:py-8 bg-white relative overflow-hidden mobile-compact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollAnimation animation="fade-in">
          <div className="text-center mb-16 max-md:mb-6 mobile-compact-spacing">
            <h2 className="text-4xl md:text-5xl max-md:text-2xl font-bold text-secondary mb-4 max-md:mb-2">
              Choose Your Perfect Shade
            </h2>
            <p className="text-xl max-md:text-sm text-gray-600 max-w-3xl mx-auto mobile-compact-text">
              From subtle enhancement to maximum privacy, we offer a complete range of tint shades to match your style and needs.
            </p>
          </div>
        </ScrollAnimation>

        {/* Tint Comparison Visual */}
        <ScrollAnimation animation="slide-up">
          <div className="relative mb-16 max-md:mb-6 mobile-compact-spacing">
            <div
              className="h-96 max-md:h-48 rounded-2xl max-md:rounded-lg overflow-hidden shadow-2xl bg-cover bg-center"
              style={{
                backgroundImage: 'url(https://img1.wsimg.com/isteam/ip/9ebfc883-4205-41ee-a091-a5f3a9011f92/blob-0005.png)',
              }}
            >
              <div className="h-full flex">
                {shades.map((shade, index) => (
                  <div
                    key={shade.percentage}
                    className="flex-1 relative group cursor-pointer transition-all duration-300 hover:flex-[1.2]"
                    style={{
                      backgroundColor: `rgba(0, 0, 0, ${1 - parseInt(shade.percentage) / 100})`,
                    }}
                  >
                    <div className="absolute inset-0 flex flex-col items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/30">
                      <div className="text-4xl max-md:text-xl font-bold mb-2 max-md:mb-1">{shade.percentage}</div>
                      <div className="text-lg max-md:text-xs font-semibold whitespace-nowrap">{shade.name}</div>
                      <div className="text-sm max-md:text-xs mt-1 whitespace-nowrap max-md:hidden">{shade.description}</div>
                    </div>
                    <div className="absolute bottom-4 max-md:bottom-2 left-1/2 transform -translate-x-1/2 text-white font-bold text-2xl max-md:text-sm">
                      {shade.percentage}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="text-center mt-6 max-md:mt-2">
              <p className="text-gray-600 max-md:text-xs font-medium">Hover over each shade to see details</p>
            </div>
          </div>
        </ScrollAnimation>

        {/* Shade Details */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4 max-md:gap-2 mobile-compact-gap">
          {shades.map((shade, index) => (
            <ScrollAnimation key={shade.percentage} animation="slide-up" delay={index * 50}>
              <div className="bg-gray-50 rounded-lg max-md:rounded p-4 max-md:p-2 text-center hover:bg-primary hover:text-white transition-all duration-300 cursor-pointer group">
                <div className="text-3xl max-md:text-lg font-bold mb-2 max-md:mb-1 group-hover:scale-110 transition-transform">
                  {shade.percentage}
                </div>
                <div className="font-semibold text-sm max-md:text-xs mb-1 whitespace-nowrap">{shade.name}</div>
                <div className="text-xs max-md:hidden opacity-75 whitespace-nowrap">{shade.description}</div>
              </div>
            </ScrollAnimation>
          ))}
        </div>

        <ScrollAnimation animation="fade-in">
          <div className="mt-12 max-md:mt-6 bg-gradient-to-r from-primary to-accent rounded-2xl max-md:rounded-lg p-8 max-md:p-4 text-white text-center mobile-compact-spacing">
            <h3 className="text-2xl max-md:text-base font-bold mb-3 max-md:mb-2">Not Sure Which Shade to Choose?</h3>
            <p className="text-lg max-md:text-xs mb-6 max-md:mb-3 opacity-90 mobile-compact-text">
              Our experts will help you select the perfect tint percentage based on your preferences, local regulations, and vehicle type.
            </p>
            <a href="tel:4438000348" className="inline-block bg-white text-primary px-8 max-md:px-4 py-3 max-md:py-2 rounded-lg max-md:rounded font-semibold max-md:text-sm hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line mr-2 max-md:text-xs"></i>
              Call for Free Consultation
            </a>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
